module.exports = __webpack_public_path__ + "static/img/introduction-sustainability-un-sustainable.75d23c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/introduction-sustainability-un-sustainable.png
// module id = ruo1
// module chunks = 0